<template>
    <div class="container-fluid section">
        <div class="row heading">
            <div class="col-12 col-lg-3">
                <h2>Leads</h2>
            </div>

            <div class="col-12 col-lg-9 text-right">
                <div style="width: 250px; display: inline-block;">
                    <show-hide-cols
                            :cols="cols"
                            :selected="filters.columns"
                    ></show-hide-cols>
                </div>
                <save-report></save-report>
                <save-chart
                        :xOpts="cols"
                        :yOpts="cols"
                        fn="accounts"
                        :filters="filters"
                ></save-chart>

                <button class="btn btn-light" @click="showAddLead = true;"><i class="fa fa-plus"></i> &nbsp;New Lead</button>&nbsp;

                <button class="btn btn-light" @click="clearFilters"><i class="fa fa-remove"></i> &nbsp;Clear Filters</button>&nbsp;


                <download
                        fn="accounts"
                        :filters="filters"
                        :cols="cols"
                ></download>
                &nbsp;&nbsp;
                <paginate
                        :page-count="num_pages"
                        :initial-page="parseInt(filters.page - 1)"
                        :page-range="1"
                        :margin-pages="1"
                        :click-handler="paginateClick"
                        container-class="pagination"
                        page-class="page-item"
                        page-link-class="page-link"
                        prev-class="page-item"
                        prev-link-class="page-link"
                        next-class="page-item"
                        next-link-class="page-link"
                ></paginate>
            </div>
        </div>

        <full-table
                headerClass="table-head"
                filterClass="table-filter table-subhead"
                :cols="cols"
                :data="tableData"
                filterInputClass="form-control"
                :filters="filters"
                @filter="fetch"
        >

            <template
                    v-for="col in cols"
                    v-if="meta && meta[col.key]"
                    :slot="col.key + '_heading'"
            >
                <span v-tooltip.bottom="metaValues(meta[col.key])">
                    {{ col.display }}
                    <i class="fa fa-info-circle" style="font-size: 12px;"></i>
                </span>
            </template>

            <template slot="created_on_filter" scope="props">

                <timeframe
                        :timeframes="timeframes"
                        :groups="groups"
                        v-model="filters.search.created_on"
                >
                </timeframe>
            </template>

            <template slot="followup_on_filter" scope="props">

                <timeframe
                        :timeframes="timeframes"
                        :groups="groups"
                        v-model="filters.search.followup_on"
                >
                </timeframe>
            </template>
            <template slot="estimated_mrc_filter" scope="props">



                <range-filter
                        v-model="filters.search.estimated_mrc"
                        label="$"
                >
                </range-filter>

           </template>

            <template slot="lead_name_data" scope="props">
                <router-link :to="'leads/' + props.data.lead_id"> {{ props.value }} </router-link>
            </template>


            <template slot="created_on_data" scope="props">
                {{ props.value | formatDate }}
            </template>

            <template slot="followup_on_data" scope="props">
                {{ props.value | formatDate }}
            </template>

            <pulse-loader style="text-align:center;" slot="loading" v-show="loading" color="#5e9cd3"></pulse-loader>

        </full-table>

        <modal v-if="showAddLead" size="lg" >
            <div slot="header">
                <h3 class="modal-title d-inline d-flex justify-content-start">Add Lead</h3>
                <button type="button" class="btn btn-clear close-btn"  @click="showAddLead = false" >
                    <i class="fa fa-remove" />
                </button>
                </h3>
            </div>
            <add-lead slot="body" @close="showAddLead = false"></add-lead>
        </modal>

        <modal v-if="showAccountAgents" size="lg" @close="showAccountAgents = false">
            <div slot="header">
                <h3 class="modal-title d-inline d-flex justify-content-start">Account Agents</h3>
                <button type="button" class="btn btn-clear close-btn" @click="showAccountAgents = false" >
                    <i class="fa fa-remove"  />
                </button>
                </h3>
            </div>
            <div slot="body">
                <account-agents
                        :account_id="selectedAccount_id"
                        @close="showAccountAgents = false"
                        slot="body"
                ></account-agents>
            </div>
        </modal>
    </div>
</template>

<script type="text/babel">
    var Paginate = require('vuejs-paginate');
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import FullTable from '../assets/FullTable.vue';
    import ShowHideCols from '../assets/ShowHideCols.vue';
    import SaveReport from '../assets/SaveReport.vue';
    import SaveChart from '../assets/SaveChart.vue';
    import Download from '../assets/Download.vue';
    import Dropdown from '../assets/Dropdown.vue';
    import MultiSelect from '../assets/MultiSelect.vue';
    import Datepicker from 'vuejs-datepicker';
    import AddLead from './AddLead.vue';

    import Modal from '../assets/Modal.vue';
    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
    import Timeframe from '../assets/Timeframe.vue';
    import RangeFilter from '../assets/RangeFilter.vue';

    import { metaData } from '../../mixins/metaData.js';
    export default {
        name: 'Leads',
        data () {
            return {
                styleObj:{
                    width: '320px',
                    textAlign: 'right'
                },
                meta: {},
                filters: {
                    search:{
                        created_on: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        followup_on: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        customer_name: '',
                        estimated_mrc: [null,null],
                        status: '',
                        sales_team: '',
                        lead_creator: ''
                    },
                    sort: [{
                        field: 'created_on',
                        dir: 'DESC'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                },
                num_pages: 0,
                cols:[
                    {
                        key:        'lead_name',
                        display:    'Lead Name',
                        filter:     true,
                        sortable:   true,
                        width:      275,
                        sort:       0

                    },
                    {
                        key:        'created_on',
                        display:    'Created On',
                        filter:     "Object",
                        sortable:   true,
                        width:      275,
                        sort:       1

                    },
                    {
                        key:        'followup_on',
                        display:    'Followup On',
                        filter:     "Object",
                        sortable:   true,
                        width:      275,
                        sort:       2

                    },

                    {
                        key:        'status',
                        display:    'Status',
                        filter:     true,
                        sortable:   true,
                        width:      150,
                        sort:       4

                    },
                    {
                        key:        'sales_team',
                        display:    'Sales Team',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       5
                    },
                    {
                        key:        'lead_creator',
                        display:    'Lead Creator',
                        filter:     true,
                        sortable:   true,
                        width:      250,
                        sort:       6
                    }

                ],
                approvals:['Approved', 'Unapproved'],
                timeframes:[ 'Month To Date', 'Last 30 days', 'Last Month', 'Quarter To Date', 'Last Quarter', 'Year To Date', 'Last One Year', 'Last Year', 'Lifetime', 'Custom'],
                groups: [
                    'Date', 'Week', 'Month', 'Year'
                ],
                mrcs:[null,null],
                comms:[null,null],
                recentComs:[null,null],
                accountStatuses:[],
                tableData:[],
                loading: false,
                todaysDate:{
                    to: new Date().setHours(23,59,59,999),
                    from: new Date().setHours(0,0,0,0)
                },
                showAddLead: false,
                showAccountAgents: false,
                selectedAccountAgents: [],
                agents:[]
            }
        },
        components:{
            Paginate,
            FullTable,
            PulseLoader,
            ShowHideCols,
            SaveReport,
            Download,
            SaveChart,
            Dropdown,
            MultiSelect,
            Datepicker,
            AddLead,
            DropdownConfirmation,
            Modal,
            Timeframe,
            RangeFilter

        },
        mounted(){
            if(!this.userReport_id && localStorage.getItem('leadFilters')){
                this.filters = JSON.parse(localStorage.getItem('leadFilters'));
            }
        },
        created(){

//            this.fetchStatuses();
//            this.fetchAgents();
//            if(!this.$canAccess(8, 10)){
//                this.cols = this.cols.filter(function(col){
//                    return col.key != "approved";
//                })
//            }
//
//            this.comms = JSON.parse(JSON.stringify(this.filters.search.latest_comms));
//            this.mrcs = JSON.parse(JSON.stringify(this.filters.search.account_mrc));
        },
        computed:{
            selectedColumnObj(){
                var _this = this;
                return this.cols.filter(function (c){ return _this.filters.columns.indexOf(c.key) >= 0 });
            },
            getApprovedText(){
                if(this.filters.search.approved == null) return null;
                if(this.filters.search.approved == 1) return 'Approved';
                if(this.filters.search.approved == 0) return 'Unapproved';
            },
            canApprove(){
                return  this.$store.getters.getUserRoles[8].rolesPermissions[10].state;
            },
            getStatusList(){
                return this.accountStatuses.map(function(status){
                    return status.name;
                });
            },
            getAgentList(){
                return this.agents.map(function(u){
                    return u.name;
                });
            },
            getSelectedStatuses(){
                var _this = this;
                if(!this.accountStatuses) return false;
                return this.accountStatuses.filter(function(s){
                    return _this.filters.search.account_status.indexOf(s.id) >=0;
                }).map(function(s){
                    return s.name;
                });
            },
            getSelectedSubagents(){
                var _this = this;
                console.log(this.agents.length);
                if(!this.agents) return false;
                return this.agents.filter(function(u){
                    return _this.filters.search.subagents.indexOf(u.user_id) >=0;
                }).map(function(u){
                    return u.name;
                });
            }
        },
        filters:{
            formatMoney(n){
                if(!n) return ' - ';

                var c = 2,
                        d = '.',
                        t = ',',
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return "$" + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");

            },
            formatInteger(n){
                if(!n) return ' - ';
                var c = 0,
                        d = '.',
                        t = ',',
                        s = n < 0 ? "-" : "",
                        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
                        j = (j = i.length) > 3 ? j % 3 : 0;
                return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
            },
            formatDate(val){
                if(!val) return '';
                return moment(val).format('MM/DD/YYYY');
            }
        },
        methods:{
            metaUnique(obj){
                if(!obj) return;
                return '<span class="total-key">Unique</span><span class="total-value">' + this.$options.filters.formatInteger(obj.unique) + '</span>';
            },
            metaDollar(obj){
                if(!obj) return;

                var html = '<span class="total-key">Total</span>' +
                        '<span class="total-value">' + this.$options.filters.formatMoney(obj.total) + '</span>' +
                        '<span class="total-key">Count</span>' +
                        '<span class="total-value">' + this.$options.filters.formatInteger(obj.count) + '</span>' +
                        '<span class="total-key">Avg</span>' +
                        '<span class="total-value">' + this.$options.filters.formatMoney(obj.average) + '</span>';
                return html;

            },
            setMrcs(){
                this.$set(this.filters.search.account_mrc, 0, this.mrcs[0]);
                this.$set(this.filters.search.account_mrc, 1, this.mrcs[1]);

            },
            setComs(){
                this.$set(this.filters.search.latest_comms, 0, this.comms[0]);
                this.$set(this.filters.search.latest_comms, 1, this.comms[1]);
            },
            paginateClick(pageNum){
                this.filters.page = pageNum;
            },
            fetch: _.debounce(function(filters){

                var _this = this;
                var timeout = {};
                this.tableData = [];

                // data = (filters) ? Object.assign({}, filters) : this.filters;
                this.loading = true;
                var data = JSON.parse(JSON.stringify(this.filters));

                this.timer = moment().valueOf();
                data.time = this.timer;
                data.offset = this.filters.limit * (this.filters.page - 1) || 0;
                data.limit = this.filters.limit;


                _this.$send(_this, 'leads',  data).then(r => {

                    _this.loading = false;
                    _this.tableData = r.leads;
                    _this.num_pages = Math.ceil(r.count / _this.filters.limit);
                    _this.meta = Object.assign({}, _this.meta, r.meta);

                    if(!_this.userReport_id){
                        localStorage.setItem('leadFilters', JSON.stringify(_this.filters));
                    }
                });
            }, 400),
            fetchStatuses(){
                this.$send(this, 'accountStatuses').then(r => {
                    this.accountStatuses = r.accountStatuses;
                });
            },
            fetchAgents(){
                this.$send(this, 'userUsers', { sort: [{dir: 'ASC',field: 'name' }]}).then(r => {
                    this.agents = r.userUsers;
                    this.fetch();
                });
            },
            setApprovedVal(val){

                if(!val) this.filters.search.approved = null;
                if(val =='Approved') this.filters.search.approved = 1;
                if(val =='Unapproved') this.filters.search.approved = 0;
            },
            approve(account_id, approval, index){
                this.$send(this, 'accountUpdate',  {
                    account_id: account_id,
                    approved:approval
                }).then(r => {
                    this.tableData[index].approved = approval;
                });
            },
            setAccountStatus(value){
                if(this.filters.search.account_status.indexOf(value) >=0){
                    this.filters.search.account_status.splice(this.filters.search.account_status.indexOf(value), 1)
                } else {
                    this.filters.search.account_status.push(value);
                }
            },
            setSubagents(value){
                var subagent_id = this.agents.filter(u => { return u.name == value }).map(u => { return u.user_id})[0] || null;
                if(!subagent_id) return null;
                if(this.filters.search.subagents.indexOf(subagent_id) >=0){
                    this.filters.search.subagents.splice(this.filters.search.subagents.indexOf(subagent_id), 1)
                } else {
                    this.filters.search.subagents.push(subagent_id);
                }
            },
            fetchAccountAgents(account_id){
                this.selectedAccount_id = account_id;
                this.showAccountAgents = true;
            },
            clearFilters(){
                localStorage.setItem('leadFilters', '');
                this.resetFilters();

            },
            resetFilters(){
                this.filters = {
                    search:{
                        created_on: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        followup_on: {
                            timeframe: '',
                            start: '',
                            end: '',
                            group: ''
                        },
                        customer_name: '',
                        estimated_mrc: [null,null],
                        status: '',
                        sales_team: '',
                        lead_creator: ''
                    },
                    sort: [{
                        field: 'created_on',
                        dir: 'DESC'
                    }],
                    columns:[],
                    limit: 25,
                    page: 1
                }
            }
        },
        mixins: [metaData]
    }
</script>

<style>
    .inline-input-holder{
        display:inline-block; width: 125px;
    }

    .total-key{
        color: #545454;
        font-weight: 500;
        display: block;
        text-transform: uppercase;
        font-size: 11px;
    }

    .total-value{
        font-weight: 800;
        display: block;
        margin-bottom: 5px;
    }


    .tooltip {
        display: block !important;
        padding: 4px;
        z-index: 10000;
    }
    .tooltip-inner {
        background: #202020;
        color: white;
        border-radius: 3px;
        padding: 5px 10px 4px;
        text-align:left;
    }

    .tooltip-arrow {

    }

    .tooltip[aria-hidden='true'] {
        visibility: hidden;
        opacity: 0;
        transition: opacity .15s, visibility .15s;
    }

    .tooltip[aria-hidden='false'] {
        visibility: visible;
        opacity: 1;
        transition: opacity .15s;
    }



</style>


// WEBPACK FOOTER //
// Index.vue?38a9a8f1